import { render } from "./CustomDiscounts.vue?vue&type=template&id=49a1fb79"
import script from "./CustomDiscounts.vue?vue&type=script&lang=js"
export * from "./CustomDiscounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__